// Comprehensive Verified Customer Testimonials for Shutter Services Hyderabad
export const testimonialsData = [
  {
    id: 1,
    name: 'Ramesh Kumar',
    initial: 'R',
    role: 'Electronics Retail Owner',
    locality: 'Ameerpet, Hyderabad',
    service: 'Emergency Shutter Jam Repair',
    date: '24 Sep 2026',
    rating: 5,
    verified: true,
    text: 'Our main showroom shutter jammed sideways right as we were opening for Dussehra festival footfall. The technician arrived in just 45 minutes with a mobile repair van, safely released the seized torsion spring, and replaced 3 damaged slats without charging emergency surge fees. Invaluable rapid service.'
  },
  {
    id: 2,
    name: 'Sridevi Rao',
    initial: 'S',
    role: 'Operations Director, IT Park',
    locality: 'Kondapur, Hyderabad',
    service: 'Automatic Motor Conversion & Smart App Hub',
    date: '18 Sep 2026',
    rating: 5,
    verified: true,
    text: 'Converted our heavy 18-foot manual basement security shutter to an automated wireless remote system. The team installed a pure copper-wound side motor and integrated mobile app controls so security staff can monitor door cycles remotely. Silent, smooth, and extraordinarily reliable.'
  },
  {
    id: 3,
    name: 'Mohammed Aslam',
    initial: 'M',
    role: 'Logistics Facility Manager',
    locality: 'LB Nagar, Hyderabad',
    service: 'Industrial Heavy-Duty Shutter Fabrication',
    date: '12 Sep 2026',
    rating: 5,
    verified: true,
    text: 'Commissioned two 24x16 ft industrial shutters for our cargo fulfillment hub. From engineering site survey to structural hot-dip galvanized slat installation, the craftsmanship was top tier. Includes anti-drop safety brakes and wind lock guides. Exceeded our expectations.'
  },
  {
    id: 4,
    name: 'K. Venkat Reddy',
    initial: 'V',
    role: 'Pharmacy Chain Proprietor',
    locality: 'Madhapur, Hyderabad',
    service: 'Midnight Breakdown Restoration',
    date: '05 Sep 2026',
    rating: 5,
    verified: true,
    text: 'At 11:30 PM, our 24/7 medical store shutter broke its internal winding cable and would not roll down. Shutter Services dispatch sent their night emergency squad within 40 minutes. They safely secured the premises, replaced the tension cable, and handed over a verified digital service invoice on the spot.'
  },
  {
    id: 5,
    name: 'Ananya Sharma',
    initial: 'A',
    role: 'Jewellery Showroom Manager',
    locality: 'Banjara Hills, Hyderabad',
    service: 'Architectural Polycarbonate Shutter Install',
    date: '28 Aug 2026',
    rating: 5,
    verified: true,
    text: 'We required transparent polycarbonate rolling shutters for high-end boutique display security after closing hours. Shutter Services provided crystal-clear scratch-resistant composite panels with tubular motor operation. Our storefront looks stunning and meets insurance vault standards.'
  },
  {
    id: 6,
    name: 'Suresh Naidu',
    initial: 'S',
    role: 'Commercial Complex Secretary',
    locality: 'Secunderabad, Hyderabad',
    service: 'Annual Maintenance Contract (AMC)',
    date: '19 Aug 2026',
    rating: 5,
    verified: true,
    text: 'Signed an AMC for all 36 basement and retail shutters across our commercial arcade. Their quarterly 18-point mechanical inspections, laser alignment, and high-temp bearing lubrication have reduced breakdowns to absolute zero. Professional GST billing and transparent itemized reports.'
  },
  {
    id: 7,
    name: 'Dr. P. Rajasekhar',
    initial: 'R',
    role: 'Diagnostic Center Administrator',
    locality: 'Kukatpally, Hyderabad',
    service: 'Rapid Roll-Up Door & Safety Sensor Retrofit',
    date: '10 Aug 2026',
    rating: 5,
    verified: true,
    text: 'Upgraded our ambulance bay entrance with a fast-acting motorized shutter equipped with infrared obstacle detection sensors. Technicians tested full automated reversal cycles 15 times before sign-off. Outstanding engineering precision and courtesy.'
  },
  {
    id: 8,
    name: 'Farhan Siddiqui',
    initial: 'F',
    role: 'Auto Body Workshop Owner',
    locality: 'Cherlapally, Hyderabad',
    service: 'High-Tensile Torsion Spring Replacement',
    date: '02 Aug 2026',
    rating: 5,
    verified: true,
    text: 'A snapped torsion spring left our vehicle bay shutter dead weight. Their technician arrived with oil-tempered calibrated replacement springs, used safety winding bars, and rebalanced the curtain so effortlessly that it now lifts with a single finger touch.'
  },
  {
    id: 9,
    name: 'Lakshmi Prasanna',
    initial: 'L',
    role: 'Supermarket Owner',
    locality: 'KPHB Colony, Hyderabad',
    service: 'Perforated Grill Shutter Fabrication',
    date: '25 Jul 2026',
    rating: 5,
    verified: true,
    text: 'Installed perforated ventilation shutters for our grocery and dairy storage facade. Allows optimal continuous airflow while keeping rodents and unauthorized entry completely locked out. Very satisfied with the heavy-gauge powder-coated finish.'
  },
  {
    id: 10,
    name: 'G. Harish Chandra',
    initial: 'H',
    role: 'Manufacturing Plant Engineer',
    locality: 'Balanagar, Hyderabad',
    service: '3-Phase Industrial Motor & Gearbox Overhaul',
    date: '18 Jul 2026',
    rating: 5,
    verified: true,
    text: 'Our 5HP industrial shutter gearbox began emitting grinding noise during peak dispatch hours. Shutter Services disassembled the drive assembly, replaced the bronze worm gear, and refilled synthetic gear oil within 3 hours on-site, preventing plant shutdown.'
  },
  {
    id: 11,
    name: 'Vikram Mehta',
    initial: 'V',
    role: 'Textile Wholesale Hub',
    locality: 'Begumpet, Hyderabad',
    service: 'Central Security Lock & Guide Rail Replacement',
    date: '11 Jul 2026',
    rating: 5,
    verified: true,
    text: 'After an attempted lock tampering on our textile godown, we needed reinforced bullet-catch side locks and heavy steel channel guides installed immediately. The team completed the overhaul the very same morning with anti-cut hardened steel fixtures.'
  },
  {
    id: 12,
    name: 'Pooja Agarwal',
    initial: 'P',
    role: 'Boutique Cafe Owner',
    locality: 'Gachibowli, Hyderabad',
    service: 'Custom Powder-Coated Aluminium Shutter',
    date: '04 Jul 2026',
    rating: 5,
    verified: true,
    text: 'Customized a matte-charcoal motorized shutter that perfectly integrates with our cafe storefront aesthetic. Whisper-quiet tubular motor with push-button operation. The team left the site spotless and provided comprehensive operating instructions.'
  }
];
